import { call } from 'redux-saga/effects';

import { logOut } from '@api/auth';
import { destroyToken, getUser } from '@helpers/user';
import { history, vsuiteRoutes } from '@routes';

export const logOutSaga = function* () {
  try {
    const { refresh } = getUser();

    yield call(destroyToken);
    yield call(history.push, vsuiteRoutes.LOGIN.make({ returnTo: vsuiteRoutes.DASHBOARD.make() }));
    yield call(logOut, refresh);
  } catch (e) {
    // Do nothing
  }
};
